import { TableCell, TableRow } from '@fluentui/react-components';
import { useStyles } from './styles.js';

export function ResizableTableDividerBottom({ size }: { size: number | string }) {
    const styles = useStyles();

    return (
        <TableRow className={styles.row}>
            <TableCell
                className={styles.cell}
                // @ts-expect-error
                colSpan="100%"
            >
                <div
                    className={styles.divider}
                    style={{
                        insetInline: size,
                    }}
                />
            </TableCell>
        </TableRow>
    );
}
